import { Injectable } from '@angular/core';
import { FeatureFlagData } from '@suiteux/suiteux-shell';

import { LocalStorageService } from './local-storage.service';
import { ShellShimService } from './shell-shim.service';

@Injectable({
    providedIn: 'root'
})
export class FeatureManagerService {
    private static readonly localStorageKey = 'ShellFeatureFlags';

    constructor (
        private readonly localStorageService: LocalStorageService,
        private readonly shellShimService: ShellShimService
    ) {}

    public static parseBooleanFlagsAndFilter(object: any, keysToIgnore = new Set<string>()): Record<string, boolean> {
        return Object.keys(object)
            .filter(key => typeof object[key] === 'boolean' && !keysToIgnore.has(key))
            .reduce((obj, key) => {
                obj[key] = object[key];
                return obj;
            }, {});
    }

    public registerFlagsAndGetConfig(flagData: FeatureFlagData): Record<string, boolean> {
        this.registerFeatures(flagData);
        return this.mergeConfigWithOverrides(flagData);
    }

    private mergeConfigWithOverrides(flagData: FeatureFlagData): Record<string, boolean> {
        const overrides = this.getOverrides();
        const mergedConfig = Object.keys(flagData).reduce((obj, key) => {
            obj[key] = overrides[key] ?? flagData[key];
            return obj;
        }, {});

        return mergedConfig;
    }

    private getOverrides(): Record<string, boolean> {
        return this.localStorageService.getGlobal(FeatureManagerService.localStorageKey) ?? {};
    }

    private async registerFeatures(flagData: FeatureFlagData) {
        const shim = await this.shellShimService.getShellShim();
        shim.FeatureFlags.AddFeatureFlags(flagData);
    }
}
